export * from "../../_util/config-context/use-config";
export * from "../../_util/config-context/with-config";
//# sourceMappingURL=index.js.map